import type { ArchbaseRemoteApiClient } from '@archbase/data'
import { injectable, inject } from 'inversify'
import { ARCHBASE_IOC_API_TYPE } from '@archbase/core'
import type { AuditListResponse } from '@domain/audit/AuditDto'

@injectable()
export class DoclenzAuditService {
  constructor(@inject(ARCHBASE_IOC_API_TYPE.ApiClient) private client: ArchbaseRemoteApiClient) {}

  /** Trilha administrativa, mais recente primeiro. */
  async findAll(params: {
    action?: string
    tenantId?: string
    limit?: number
  } = {}): Promise<AuditListResponse> {
    const query = new URLSearchParams()
    if (params.action) query.set('action', params.action)
    if (params.tenantId) query.set('tenantId', params.tenantId)
    query.set('limit', String(params.limit ?? 100))
    return this.client.get(`/v1/admin/audit?${query.toString()}`)
  }
}
